$(function() {
	$('button#cancel').click(function() {
		window.history.back();
	});
	$('input.headline').first().focus();
	$('.thumbnail').hover(function() {
		$('.delete', this).toggle();
	});
	$('.delete').hover(function() {
		$(this).siblings('a').toggleClass('hover');
	});

	$('.filter__switch button').on('click', function() {
		var $body = $('body');
		if ($body.is('.mapView')) {
			$body.removeClass('mapView');
		} else {
			$body.addClass('mapView');
		}
	});
});

var datafilter = (function ($) {
	"use strict";
	var $dataFilter,
		init = function () {
			$dataFilter = $('.filterControls', '.portfolio');
			if ($dataFilter.length > 0) {
				datafilter.main.init();
			}
		};
	$(document).ready(init);
	return {
		$: $,
		g: function () {
			return $dataFilter.closest('.box');
		}
	};
})(jQuery);

datafilter.main = (function (parent) {
	"use strict";
	var $ = parent.$,
		$form,
		$input,
		$select,
		$link,
		$list,
		init = function () {
			$list = parent.g().find('.item');
			jQuery.expr[':'].startsWith = function (a, i, m) {
				//noinspection JSConstructorReturnsPrimitive
				var t = $(a).text().replace(/^\s*/, '').substring(0, 1);
				return (t || "").toUpperCase().indexOf(m[3].toUpperCase()) >= 0;
			};
			jQuery.expr[':'].containsIC = function (a, i, m) {
				var t = $(a).text();
				return (t || "").toUpperCase().indexOf(m[3].toUpperCase()) >= 0;
			};
			initSearch();
		},
		initSearch = function () {
			$form = parent.g().find('form');
			$form.on('submit', function(e) {
				e.preventDefault();
			});
			$input = $form.find('input').keyup(function (e) {
				//if (e.which == 13) { // Enter
				var t = this;
				doSearch.call(t);
				$('#property-list .item').each(function() {
					if ($(this).parent().is('span')) {
						$(this).unwrap();
					}
				});
				$('#property-list .item.hide').wrap('<span></span>');

				console.log($items.length);
				//}
			});
		},

		doSearch = function (e) {
			if (e) {
				e.preventDefault();
			}
			var $this = $(this),
				$res = $list,
				t = this.tagName;

			//Searching
			if (t === 'INPUT') {
				var searchValue = $input.val();
				if (searchValue) {
					$res = $res.find(':containsIC("' + searchValue + '")').parent();
				}
			}

			result($res);
		},
		result = function ($filtered) {
			if ($filtered) {
				$list.addClass('hide');
				$filtered.removeClass('hide')
			}
			else {
				$list.removeClass('hide')
			}
		};
	return {
		init: init
	};
})(datafilter);


